module.exports = __webpack_public_path__ + "static/img/image012.84719be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image012.png
// module id = gs97
// module chunks = 1